import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { GradientSpinner } from '@/core/components';
import { getNftMediaUrl } from '@/core/services/storage';
import type { Claim } from '@/core/types';

interface CertDetailDialogProps {
  claim: Claim | null;
  open: boolean;
  onClose: () => void;
}

export function CertDetailDialog({ claim, open, onClose }: CertDetailDialogProps) {
  const [videoUrl, setVideoUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!claim || !open) {
      setVideoUrl(null);
      setLoading(true);
      return;
    }

    const fetchVideo = async () => {
      try {
        if (claim.fileName) {
          const url = await getNftMediaUrl({
            fileName: claim.fileName,
            raceAlias: claim.raceAlias,
          });
          setVideoUrl(url);
        }
      } catch (err) {
        console.error('Failed to load video:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchVideo();
  }, [claim, open]);

  if (!claim) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8, zIndex: 1 }} aria-label="閉じる">
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ p: 3 }}>
        <Box sx={{ textAlign: 'center' }}>
          {loading ? (
            <Box sx={{ py: 8, display: 'flex', justifyContent: 'center' }}>
              <GradientSpinner />
            </Box>
          ) : videoUrl ? (
            <video src={videoUrl} controls autoPlay muted style={{ maxWidth: 480, width: '100%', borderRadius: 8 }} />
          ) : (
            <Typography color="text.secondary">動画を読み込めませんでした</Typography>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
